export default __webpack_public_path__ + "static/media/magic.256a7459.svg";